export const constant = {
	selector: {
		target: '.feedback-messenger-window',
		targetWysiwyg: '.feedback-messenger-window .wysiwyg',
		subjectInputTarget: '.feedback-messenger-window #subject',
		handler: 'data-clm-on-change',
		requiredSubjectPart: 'data-clm-required-subject-part',
	},
}
